import { render } from "./OrderAuth.vue?vue&type=template&id=2776a9f8&scoped=true"
import script from "./OrderAuth.vue?vue&type=script&lang=js"
export * from "./OrderAuth.vue?vue&type=script&lang=js"

import "../assets/flower.css?vue&type=style&index=0&lang=css"
import "./OrderAuth.vue?vue&type=style&index=1&id=2776a9f8&scoped=true&lang=css"

import exportComponent from "D:\\code\\miao_up_up_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2776a9f8"]])

export default __exports__